import { Controller } from "@hotwired/stimulus"

export default class PanelTimerController extends Controller {
  static targets = ["display", "ariaAnnounce"]
  static values = { endsAt: String, soundUrl: String, expiredText: String }

  declare displayTarget: HTMLElement
  declare ariaAnnounceTarget: HTMLElement
  declare hasAriaAnnounceTarget: boolean
  declare endsAtValue: string
  declare soundUrlValue: string
  declare hasSoundUrlValue: boolean
  declare expiredTextValue: string
  declare hasExpiredTextValue: boolean

  private intervalId: ReturnType<typeof setInterval> | null = null
  private endsAtMs = 0
  private expired = false

  connect(): void {
    this.endsAtMs = new Date(this.endsAtValue).getTime()
    this.expired = false
    this.tick()
    this.intervalId = setInterval(() => this.tick(), 100)
  }

  disconnect(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
  }

  private playTimeupSound(): void {
    if (this.hasSoundUrlValue) {
      const audio = new Audio(this.soundUrlValue)
      audio.play().catch((e) => { console.warn("[panel-timer] Audio play failed:", e.message || e) })
    }
  }

  private announceOnce10 = false

  private tick(): void {
    const remaining = Math.max(0, this.endsAtMs - Date.now())
    const seconds = Math.ceil(remaining / 1000)

    this.displayTarget.textContent = String(seconds)

    if (seconds <= 10 && seconds > 0) {
      this.element.classList.add("panel-timer--warning")
      if (!this.announceOnce10 && this.hasAriaAnnounceTarget) {
        this.announceOnce10 = true
        this.ariaAnnounceTarget.textContent = String(seconds)
      }
    }

    if (remaining <= 0 && !this.expired) {
      this.expired = true
      if (this.intervalId) {
        clearInterval(this.intervalId)
        this.intervalId = null
      }
      this.element.classList.add("panel-timer--expired")
      this.playTimeupSound()

      if (this.hasAriaAnnounceTarget) {
        const text = this.hasExpiredTextValue ? this.expiredTextValue : "Time is up"
        this.ariaAnnounceTarget.textContent = ""
        requestAnimationFrame(() => {
          this.ariaAnnounceTarget.textContent = text
        })
      }

      this.element.dispatchEvent(
        new CustomEvent("panel-timer:expired", { bubbles: true })
      )
    }
  }
}
